<template>
  <!-- 帮帮-发布服务 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 帮帮-店铺管理 发布服务-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBack">店铺管理</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBack">店铺商品</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">编辑/发布服务</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 编辑/发布服务 标题 -->
        <div class="top-title">
          <p class="title">编辑/发布服务</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
        <!-- 区块 标题 -->
        <div class="headline">基本信息</div>
        <!-- 服务编辑输入区 -->
        <div class="form-box">
          <div class="aroundModule">
            <!-- 服务名称 -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>服务名称：
              </p>
              <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
            </div>
            <!-- 服务标签 -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>服务标签：
              </p>
              <el-select v-model="ruleForm.value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 服务版本： -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>服务版本：
              </p>
              <p
                v-for="(item, index) in EditionArr"
                :key="index"
                class="edition-p"
                :class="item.choose == true ? 'edition-select' : ''"
                @click="item.choose = !item.choose"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="aroundModule">
            <div class="container">
              <span style="color: red">*</span>封面：
              <div class="Upload-box">
                <img :src="imgSrc" alt="" v-if="imgSrc != ''" />
                <input
                  type="file"
                  @change="onFileChange"
                  ref="clearFile"
                  id="file"
                  v-if="imgSrc == ''"
                />
                <input
                  type="button"
                  value="点击上传封面"
                  class="btn firm-clickable"
                  @click="clickFile()"
                  v-if="imgSrc == ''"
                />
                <p v-if="imgSrc == ''">支持jpg、png格式，大小不超过300KB</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 区块 标题 -->
        <div class="headline">服务内容</div>
        <!-- 第一行 基础版  升级版  超级版 -->
        <div class="edition-column">
          <div>
            <p>基础版</p>
            <p>升级版</p>
            <p>超级版</p>
          </div>
        </div>
        <!-- 第二行 价格 -->
        <div class="InputLine">
          <!-- 标题 -->
          <div class="title-box">
            <p class="title">价格</p>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="Remaining-width">
              <div class="column-one"></div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input placeholder="请输入"></el-input>
                </div>
                <div class="PerFrame">
                  <el-input placeholder="请输入"></el-input>
                </div>
                <div class="PerFrame">
                  <el-input placeholder="请输入"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第三行 服务亮点 -->
        <div class="InputLine" style="background: #fbfbfb">
          <!-- 标题 -->
          <div class="title-box">
            <p class="title">服务亮点</p>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="Remaining-width">
              <div class="column-one"></div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input
                    type="textarea"
                    placeholder="请输入"
                    v-model="ruleForm.textarea"
                    maxlength="120"
                    show-word-limit
                    resize="none"
                    :autosize="true"
                  >
                  </el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    type="textarea"
                    placeholder="请输入"
                    v-model="ruleForm.textarea"
                    maxlength="120"
                    show-word-limit
                    resize="none"
                    :autosize="true"
                  >
                  </el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    type="textarea"
                    placeholder="请输入"
                    v-model="ruleForm.textarea"
                    maxlength="120"
                    show-word-limit
                    resize="none"
                    :autosize="true"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第四行 服务人员 -->
        <div class="InputLine">
          <!-- 标题 -->
          <div class="title-box">
            <div class="title">
              <p>服务人员</p>
              <div class="firm-clickable" @click="handelAddPeople">
                <p></p>
                添加
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div
              class="Remaining-width"
              v-for="(item, index) in ServicePersonnel"
              :key="index"
            >
              <div class="column-one">
                <el-input
                  placeholder="请输入"
                  :v-model="item.personnel"
                ></el-input>
                <div
                  class="delete-icon firm-clickable"
                  v-if="item.delete"
                  @click="handelDeletePeople(item, index)"
                ></div>
              </div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Basics"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Upgrades"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.super"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第五行 -->
        <div class="InputLine" style="background: #fbfbfb">
          <!-- 标题 -->
          <div class="title-box">
            <div class="title">
              <p>服务方式</p>
              <div class="firm-clickable" @click="handelAddMode">
                <p></p>
                添加
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div
              class="Remaining-width"
              v-for="(item, index) in ServiceMode"
              :key="index"
            >
              <div class="column-one">
                <el-input placeholder="请输入" :v-model="item.mode"></el-input>
                <div
                  class="delete-icon firm-clickable"
                  v-if="item.delete"
                  @click="handelDeleteMode(item, index)"
                ></div>
              </div>
              <div class="column-twe">
                <div class="PerFrame">
                  <div class="Switch">
                    是否有此服务
                    <el-switch
                      v-model="item.Basics"
                      active-color=" #409eff "
                      inactive-color="#8A8A8A"
                    >
                    </el-switch>
                  </div>
                </div>
                <div class="PerFrame">
                  <div class="Switch">
                    是否有此服务
                    <el-switch
                      v-model="item.Upgrades"
                      active-color=" #409eff "
                      inactive-color="#8A8A8A"
                    >
                    </el-switch>
                  </div>
                </div>
                <div class="PerFrame">
                  <div class="Switch">
                    是否有此服务
                    <el-switch
                      v-model="item.super"
                      active-color=" #409eff "
                      inactive-color="#8A8A8A"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第六行 交付方式 -->
        <div class="InputLine">
          <!-- 标题 -->
          <div class="title-box">
            <p class="title">交付方式</p>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="Remaining-width">
              <div class="column-one"></div>
              <div class="column-twe">
                <div class="delivery">
                  <div
                    v-for="(item, index) in TimeLimit"
                    :key="index"
                    :class="item.id == TimeLimitSelect ? 'TimeLimit' : ''"
                    @click="TimeLimitSelect = item.id"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 支付方式 分三种 第一期 -->
        <div class="InputLine" style="background: #fbfbfb">
          <!-- 标题 -->
          <div class="title-box">
            <div class="title">
              <p>一期交付</p>
              <div class="firm-clickable" @click="handelAddOneHandIn">
                <p></p>
                添加
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="period-title">
              <div class="period-title-cen">
                一期需交付(<el-input v-model="value"></el-input>)%
              </div>
            </div>
            <div
              class="Remaining-width"
              v-for="(item, index) in oneHandIn"
              :key="index"
            >
              <div class="column-one">
                <el-input
                  placeholder="请输入"
                  :v-model="item.content"
                ></el-input>
                <div
                  class="delete-icon firm-clickable"
                  v-if="item.delete"
                  @click="handelDeleteOneHandIn(item, index)"
                ></div>
              </div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Basics"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Upgrades"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.super"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 支付方式 分三种 第二期 -->
        <div class="InputLine">
          <!-- 标题 -->
          <div class="title-box">
            <div class="title">
              <p>二期交付</p>
              <div class="firm-clickable" @click="handelAddTweHandIn">
                <p></p>
                添加
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="period-title">
              <div class="period-title-cen">
                二期需交付(<el-input v-model="value"></el-input>)%
              </div>
            </div>
            <div
              class="Remaining-width"
              v-for="(item, index) in tweHandIn"
              :key="index"
            >
              <div class="column-one">
                <el-input
                  placeholder="请输入"
                  :v-model="item.content"
                ></el-input>
                <div
                  class="delete-icon firm-clickable"
                  v-if="item.delete"
                  @click="handelDeleteTweHandIn(item, index)"
                ></div>
              </div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Basics"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Upgrades"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.super"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 支付方式 分三种 第三期 -->
        <div class="InputLine" style="background: #fbfbfb">
          <!-- 标题 -->
          <div class="title-box">
            <div class="title">
              <p>三期交付</p>
              <div class="firm-clickable" @click="handelAddThreeHandIn">
                <p></p>
                添加
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="period-title">
              <div class="period-title-cen">
                三期需交付(<el-input v-model="value"></el-input>)%
              </div>
            </div>
            <div
              class="Remaining-width"
              v-for="(item, index) in threeHandIn"
              :key="index"
            >
              <div class="column-one">
                <el-input
                  placeholder="请输入"
                  :v-model="item.content"
                ></el-input>
                <div
                  class="delete-icon firm-clickable"
                  v-if="item.delete"
                  @click="handelDeleteThreeHandIn(item, index)"
                ></div>
              </div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Basics"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.Upgrades"
                  ></el-input>
                </div>
                <div class="PerFrame">
                  <el-input
                    placeholder="请输入"
                    :v-model="item.super"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 预计交付时间 -->
        <div class="InputLine">
          <!-- 标题 -->
          <div class="title-box">
            <p class="title">预计交付时间</p>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="Remaining-width">
              <div class="column-one"></div>
              <div class="column-twe">
                <div class="PerFrame">
                  <el-input placeholder="请输入"></el-input>
                </div>
                <div class="PerFrame">
                  <el-input placeholder="请输入"></el-input>
                </div>
                <div class="PerFrame">
                  <el-input placeholder="请输入"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务详情 -->
        <div class="InputLine" style="background: #fbfbfb">
          <!-- 标题 -->
          <div class="title-box">
            <p class="title">服务详情</p>
          </div>
          <!-- 第二列 -->
          <div class="Remaining">
            <div class="Remaining-width">
              <div class="column-one"></div>
              <div class="column-twe">
                <div class="ServiceBook"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部按钮区 -->
      <div class="button-box">
        <div class="button-cen">
          是否上架
          <el-switch
            v-model="value1"
            active-color=" #409eff "
            inactive-color="#8A8A8A"
          >
          </el-switch>
        </div>
        <div class="submit-box">
          <p>删除</p>
          <p class="submit">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "", //服务名称
        value: [], //选择标签
        Price: "", //服务价格
        textarea: "", //服务亮点
        Description: "", //服务展示描述
      }, //v-mode
      options: [], // 标签选项
      imgSrc: "",
      TXurl: "", //封面上传到腾讯云的地址
      EditionArr: [
        {
          name: "基础版",
          id: "1",
          choose: false,
        },
        {
          name: "升级版",
          id: "2",
          choose: true,
        },
        {
          name: "超级版",
          id: "3",
          choose: true,
        },
      ], // 版本选择
      ServicePersonnel: [
        {
          personnel: "", // 服务人员
          Basics: "", // 基础版人数
          Upgrades: "", //升级版人数
          super: "", // 超级版人数
        },
      ], // 服务人员
      ServiceMode: [
        {
          mode: "", // 服务方式
          Basics: true, //基础款有无此服务
          Upgrades: false, //升级款
          super: false, // 超级版
        },
      ], //服务方式
      TimeLimit: [
        {
          name: "全款",
          id: 1,
        },
        {
          name: "二期",
          id: 2,
        },
        {
          name: "三期",
          id: 3,
        },
      ], //几期
      TimeLimitSelect: 3, //几期选择
      value: "", // 一期需交付
      oneHandIn: [
        {
          content: "", // 交付
          Basics: true, //基础款
          Upgrades: false, //升级款
          super: false, // 超级版
        },
      ], //一期交付
      tweHandIn: [
        {
          content: "", // 交付
          Basics: true, //基础款
          Upgrades: false, //升级款
          super: false, // 超级版
        },
      ], //二期交付
      threeHandIn: [
        {
          content: "", // 交付
          Basics: true, //基础款
          Upgrades: false, //升级款
          super: false, // 超级版
        },
      ], //三期交付
      value1: false, //是否上架
    };
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {},
  methods: {
    // 添加一期交付
    handelAddOneHandIn() {
      var obj = {
        content: "", // 交付内容
        Basics: false, //基础款
        Upgrades: false, //升级款
        super: false, // 超级版
        delete: "1", //有此数据 可删除
      };
      // 点击添加 在一期交付内容后添加输入框
      this.oneHandIn.push(obj);
    },
    // 删除一期交付内容
    handelDeleteOneHandIn(item, index) {
      // 点击删除 在一期交付内容 中删除一行输入框
      this.oneHandIn.splice(index, 1);
    },
    // 添加二期交付
    handelAddTweHandIn() {
      var obj = {
        content: "", // 交付内容
        Basics: false, //基础款
        Upgrades: false, //升级款
        super: false, // 超级版
        delete: "1", //有此数据 可删除
      };
      // 点击添加 在二期交付内容后添加输入框
      this.tweHandIn.push(obj);
    },
    // 删除二期交付内容
    handelDeleteTweHandIn(item, index) {
      // 点击删除 在二期交付内容 中删除一行输入框
      this.tweHandIn.splice(index, 1);
    },
    // 添加三期交付
    handelAddThreeHandIn() {
      var obj = {
        content: "", // 交付内容
        Basics: false, //基础款
        Upgrades: false, //升级款
        super: false, // 超级版
        delete: "1", //有此数据 可删除
      };
      // 点击添加 在三期交付内容后添加输入框
      this.threeHandIn.push(obj);
    },
    // 删除三期交付内容
    handelDeleteThreeHandIn(item, index) {
      // 点击删除 在三期交付内容 中删除一行输入框
      this.threeHandIn.splice(index, 1);
    },
    // 添加服务方式
    handelAddMode() {
      var obj = {
        mode: "", // 服务方式
        Basics: false, //基础款有无此服务
        Upgrades: false, //升级款
        super: false, // 超级版
        delete: "1", //有此数据 可删除
      };
      // 点击添加 添加一条服务方式输入框
      this.ServiceMode.push(obj);
    },
    // 删除服务方式
    handelDeleteMode(item, index) {
      // 删除一条服务方式输入框
      this.ServiceMode.splice(index, 1);
    },
    // 添加服务人员
    handelAddPeople() {
      var obj = {
        personnel: "", // 服务人员
        Basics: "", // 基础版人数
        Upgrades: "", //升级版人数
        super: "", // 超级版人数
        delete: "1", //有此数据 可删除
      };
      this.ServicePersonnel.push(obj);
    },
    // 删除服务人员
    handelDeletePeople(item, index) {
      this.ServicePersonnel.splice(index, 1);
    },
    // 点击上传身份证
    clickFile(num) {
      // 上传正面
      const input = document.querySelector("#file");
      input.click();
    },
    // 调用上传文件/图片封装的js
    async onFileChange(event, opt) {
      var file = event.target.files[0] || event.dataTransfer.files[0];
      if (!file) return;
      let URL = window.URL || window.webkitURL;
      var arr = await this.$tool.onFileChangeNew(event, opt);
      if (arr && arr.code == 0) {
        this.imgSrc = URL.createObjectURL(file);
        this.TXurl = arr.TXurl;
      }
      if (this.$refs.clearFile) this.$refs.clearFile.value = "";
    },
    // 返回
    handelBack() {
      // 存入select 返回/HelpShop的同时获取到select  select中的数就是该页面所在的位置

      this.$router.push({
        path: "/HelpShop/ShopProduct",
        // query: { key: 1 },
      });
    },
  },
};
</script>

<style scoped lang="less">
// /deep/.el-input__inner {
//   height: 35px !important;
//   border: 1px solid #409eff ;
// }
// 自我评价输入框的样式
/deep/.el-textarea {
  height: 70px !important;
  border-radius: 5px;
}
/deep/.el-textarea__inner {
  height: 70px !important;
  border: 1px solid #409eff ;
}
// 调整表单验证样式
/deep/.el-textarea .el-input__count {
  bottom: 0px !important;
}
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  // 区块标题
  .headline {
    display: inline-block;
    min-width: 80px;
    height: 25px;
    background-image: url("../../../../../assets/imgs/zhuangshi@3x.svg");
    background-size: 100% 38%;
    background-repeat: no-repeat;
    background-position-y: bottom;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
  }
  // 基本信息 编辑输入区
  .form-box {
    width: 100%;
    min-height: 100px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    text-align: right;
    line-height: 17px;
    font-weight: 400;
    .aroundModule {
      width: 40%;
    }
  }
  // 基本信息 编辑输入区
  .container {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    display: flex;
    margin-bottom: 20px;
    .container-title {
      min-width: 80px;
      text-align: right;
    }
    .edition-p {
      width: 90px;
      height: 33px;
      border: 1px solid #409eff ;
      border-radius: 5px;
      text-align: center;
      margin-right: 15px;
      font-size: 12px;
      color: #409eff ;
    }
    .edition-select {
      background: rgba(97, 144, 232, 0.27);
      border: 1px solid #409eff ;
    }

    .Upload-box {
      width: 250px;
      height: 140px;
      border: 1px dashed #409eff ;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
      #file {
        display: none;
      }
      #file1 {
        display: none;
      }
      input {
        border: none;
        box-shadow: none;
        outline: none;
        background-color: transparent;
        width: 100%;
        text-align: center;
        color: #409eff ;
        margin-top: 40px;
      }
      p {
        width: 100%;
        text-align: center;
        font-size: 10px;
      }
    }
  }

  //   服务内容  编辑输入区
  .edition-column {
    width: 100%;
    height: 40px;
    margin: 30px 0 15px 0;
    display: flex;
    justify-content: flex-end;
    div {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      p {
        width: 100%;
        height: 38px;
        line-height: 38px;
        background: #ffffff;
        border: 1px solid #409eff ;
        box-shadow: 0px -3px 10px 0px rgba(97, 144, 232, 0.5);
        border-radius: 10px 10px 0px 0px;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        margin-right: 10px;
      }
    }
  }
  // 输入行
  .InputLine {
    width: 100%;
    min-height: 55px;
    display: flex;
    background: #eeeeee;
    .title-box {
      width: 60px;
      margin-left: 12px;
      margin-right: 20px;
      display: flex;
      .title {
        margin: auto;
        font-size: 14px;
        color: #333333;
        display: flex;
        flex-direction: column;
        div {
          width: 100%;
          height: 18px;
          line-height: 18px;
          display: flex;
          margin-top: 8px;
          font-size: 12px;
          color: #333333;
          p {
            width: 18px;
            height: 18px;
            background-image: url("../../../../../assets/imgs/tianjia@3x.svg");
            background-size: 100% 100%;
            margin-right: 5px;
          }
        }
      }
    }
    .Remaining {
      flex: 1;
      display: flex;
      flex-direction: column;
      // flex-wrap: wrap;
      .period-title {
        width: 100%;
        min-height: 35px;
        box-sizing: border-box;
        line-height: 35px;
        margin: 10px 0 10px 0;
        display: flex;
        background: rgba(97, 144, 232, 0.2);
        border: 1px solid #409eff ;
        border-radius: 5px;
        margin-left: 125px;
        .period-title-cen {
          width: 150px;
          margin: auto;
          display: flex;
          font-size: 12px;
          color: #409eff ;
          /deep/.el-input {
            height: 35px !important;
            width: 60px;
            border: none;
          }
          /deep/.el-input__inner {
            height: 35px !important;
            width: 60px;
            border: none !important;
            background: transparent;
          }
        }
      }
      .Remaining-width {
        width: 100%;
        min-height: 35px;
        margin: 10px 0 10px 0;
        display: flex;
        // border: 1px solid gold;
        // 第一列
        .column-one {
          width: 110px;
          min-height: 35px;
          position: relative;
          // border: 1px solid green;
          .delete-icon {
            width: 16px;
            height: 17px;
            background-image: url("../../../../../assets/imgs/shanchu@3x.svg");
            background-size: 100% 100%;
            position: absolute;
            right: 5px;
            top: 13px;
          }
        }
        // 第二例
        .column-twe {
          flex: 1;
          min-height: 35px;
          margin-left: 20px;
          display: flex;
          justify-content: space-between;
          .ServiceBook {
            width: 100%;
            height: 200px;
            border: 1px solid #409eff ;
          }
          .delivery {
            width: 210px;
            height: 25px;
            margin: auto;
            display: flex;
            div {
              width: 66px;
              height: 25px;
              line-height: 25px;
              text-align: center;
              background: #ffffff;
              font-size: 12px;
              color: #666666;
            }
            div:nth-child(1) {
              border-radius: 15px 0px 0px 15px;
              border: 1px solid #409eff ;
            }
            div:nth-child(2) {
              border-top: 1px solid #409eff ;
              border-bottom: 1px solid #409eff ;
            }
            div:nth-child(3) {
              border-radius: 0px 15px 15px 0px;
              border: 1px solid #409eff ;
            }
            .TimeLimit {
              color: #ffffff;
              background: #409eff ;
            }
          }
          .PerFrame {
            width: 100%;
            min-height: 35px;
            margin-right: 10px;
            display: flex;
            font-size: 14px;
            color: #666666;
            .Switch {
              height: 30px;
              line-height: 30px;
              width: 155px;
              margin: auto;
              display: flex;
              /deep/.el-switch__core {
                margin-top: 10px;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}
// 底部按钮区
.button-box {
  width: 100%;
  height: 74px;
  background: #ffffff;
  box-shadow: 0px -5px 10px 0px rgba(153, 153, 153, 0.5);
  border-radius: 0px 0px 20px 20px;
  margin-top: -25px;
  margin-bottom: 20px;
  display: flex;
  .button-cen {
    font-size: 16px;
    height: 25px;
    line-height: 25px;
    color: #333333;
    margin: auto 0;
    margin-left: 30px;
  }
  .submit-box {
    flex: 1;
    height: 40px;
    display: flex;
    margin: auto;
    justify-content: flex-end;
    p {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #ffffff;
      border: 1px solid #999999;
      border-radius: 5px;
      font-size: 16px;
      color: #333333;
      margin-right: 30px;
    }
    .submit {
      background: #409eff ;
      color: #ffffff;
    }
  }
}
</style>
